<template>
<div class="container-main pt-0">
  <v-overlay :value="isLoading">
  <v-progress-circular indeterminate size="100"></v-progress-circular>
  </v-overlay>
  <v-list-item class="title-page">
    <template>
    <v-list-item-content>
      <v-list-item-title>
          <h3 style="margin-left:15px; margin-top :20px;font-family:Verdana;font-size:16px" > <v-icon medium>mdi-calendar-multiple-check</v-icon> Schedule List</h3> 
      
          <v-btn @click="openDialog()" rounded outlined style="margin-right :10px; margin-top : 10px; font-family:Verdana"> 
                      <v-icon>mdi-account </v-icon>
                        Schedule Employee
          </v-btn> 
          <v-btn @click="OpenRemarks()" rounded outlined style="margin-right :10px; margin-top : 10px; font-family:Verdana"> 
                      <v-icon>mdi-note-text-outline </v-icon>
                        Remarks
          </v-btn> 

      </v-list-item-title>
      <v-list-item-subtitle>
      </v-list-item-subtitle>
      
    </v-list-item-content>  

      <v-card width="500" height="100" flat>
          <v-row style="margin-top:-20px">
            <v-col cols="6" style="margin-left : 10px">
              <!-- <v-switch v-model="autoSwitch" @change="ReservedLock()" :label="lblautolock"
              style="font-family:Verdana;font-size:15px">
              </v-switch> -->
            </v-col>
            <v-col cols="6" style="margin-left : -10px;" >
             
              <v-switch v-model="switch1" @change="ReservedLock()" :label="lblLock"
              style="font-family:Verdana;font-size:15px">
              </v-switch>
              
            </v-col>
            
            <v-col cols="5" style="margin-top : -40px; margin-left : 10px"> 
                <!-- <v-text-field  style = "font-family:Verdana;"
                @blur="testFormat(timeCutoff)"
                hint = "HH:mm"  
                v-mask="mask" 
                label="Time Lock"
                placeholder = "HH:mm" 
                v-model ="timeCutoff"
                class="centered-input text--darken-3" outlined dense
                width="30"
                required>
              </v-text-field>  -->
            </v-col>
            <!-- <span style="margin-top: -20px">--</span> -->
            <v-col  cols="6" style="margin-top : -40px; margin-left : 30px">
                <v-icon color="info" > mdi-information </v-icon> 
                 <span> Time locked: 14:30 </span> <br>
                 <span class="ml-7"> Time Unlocked: 01:30 </span> <br>
                 <span v-show="isSetting" class="ml-7" style="color:blue"> Updating... </span> <br>
                  <!-- <v-text-field  style = "font-family:Verdana;"
                    @blur="testFormat(timeFinish)"
                    hint = "HH:mm"  
                    v-mask="mask" 
                    label="Set Time Unlock"
                    placeholder = "HH:mm" 
                    v-model="timeFinish"
                    class="centered-input text--darken-3" outlined dense
                    append-outer-icon="mdi-send"
                    @click:append-outer="setcutOff"
                    required>
                  </v-text-field>   -->
              </v-col>
            
          
          </v-row>
      </v-card>
      
    </template>
 
  </v-list-item> 

  <template v-if="notedRemarks">
    <div class="mt-3">
       <span style="color:red; font-weight : bold; margin-left : 15px;">Note : {{notedRemarks}}</span>
    </div>
   </template>
<v-container >   
    

  <v-dialog v-model="listDialog" persistent>
    <v-card>
      
      <v-card-title>
        <span> List of Employee w/o Reservation </span>
        <v-spacer></v-spacer>
        <span> Total number :{{ListofEmpWithoutRes.length}}</span>
        <v-spacer></v-spacer>
        <v-btn fab x-small @click="listDialog = false"> <v-icon>mdi-close</v-icon> </v-btn>
      </v-card-title>
        <v-card-text>
          <v-chip v-for="(item,q) in ListofEmpWithoutRes" :key="q" class="ml-2 mb-2">
            {{item.empName}}
          </v-chip>
        </v-card-text>
    </v-card>
    </v-dialog>  
    <v-dialog v-model="remarksDialog" persistent max-width="450">
      <v-form ref="form" v-model="validRemarks" :lazy-validation="lazy">
        <v-card>
          <v-toolbar dense color="#213c57" dark> <v-icon>mdi-note-text</v-icon>
          <span style = "font-family: Verdana;font-size:15px"> Remarks</span>

          <v-spacer></v-spacer>
            <v-btn icon @click="remarksDialog = false"><v-icon>mdi-close</v-icon></v-btn>
        </v-toolbar>
          <v-card-title>
            <!-- <span>Remarks</span>
            <v-spacer></v-spacer>
          <v-btn fab x-small @click="remarksDialog = false"> <v-icon>mdi-close</v-icon> </v-btn> -->
          </v-card-title>
          <v-card-text style="margin-bottom : -20px">
            <v-textarea
              outlined
              clearable
              clear-icon="mdi-close-circle"
              name="input-7-4"
              label="English Remarks"
              v-model="vRemarks.Eng"
              :rules="[v => !!v || 'English Remarks is required']"
            ></v-textarea>
            <v-textarea
              outlined
              clearable
              clear-icon="mdi-close-circle"
              name="input-7-4"
              label="Japanese Remarks"
              v-model="vRemarks.Jap"
              :rules="[v => !!v || 'Japanese Remarks is required']"
            ></v-textarea>
          </v-card-text>
          <v-card-actions>

            <v-switch v-model="vRemarksSwitch" :label="vRemarksSwitch ? 'Active' : 'In-Active'"
              style="font-family:Verdana;font-size:15px">
              </v-switch>
            <v-spacer></v-spacer>
            <v-btn
            :disabled="!validRemarks"
            color="success"
            rounded outlined
            @click="SaveRemarks()"
            >
            <v-icon>mdi-content-save</v-icon>
            {{btnRemarks}}</v-btn>
          </v-card-actions>

        </v-card>
      </v-form>
    </v-dialog>
    <!-- <v-divider></v-divider> -->
      
    
    <!-- <v-spacer></v-spacer>
    <span style="margin-top :10px; font-family: Verdana;font-size:16px " > <v-icon color="#ef9a9a">mdi-checkbox-blank</v-icon>Regular Reservation</span>
      <v-spacer></v-spacer>
    <span style="margin-top :10px; font-family: Verdana;font-size:16px " > <v-icon color="#fff59d">mdi-checkbox-blank</v-icon>Special Reservation</span> -->
  
        <div class="bb">
      <v-tabs  slider-color="white" centered grow  v-model="tabs" background-color="transparent"  class="mt-2 tabs">
      <v-tab active-class="tabs__item--active active" >
        <v-icon left color="#ef9a9a" >mdi-car</v-icon>
          <v-badge color="red" right >
          <template v-slot:badge v-if="RegularwithoutPlateNo !== 0">
            <span> {{ RegularwithoutPlateNo }}  </span>
          </template>
          <span style="font-family:Verdana;font-weight:bold"> Regular Reservation</span>
        </v-badge>
      </v-tab>

      <v-tab active-class="tabs__item--active active">
        <v-icon left color="yellow lighten-3" >mdi-car</v-icon>
        <v-badge color="red" right>
          <template v-slot:badge v-if="SpecialwithoutPlateNo !== 0">
            <span> {{ SpecialwithoutPlateNo }}  </span>
          </template>
          <span style="font-family:Verdana;font-weight:bold">Special Reservation</span>
        </v-badge>
        </v-tab>
      </v-tabs>
        </div>
      <v-tabs-items v-model="tabs">
      
    <v-tab-item> 
      <!-- <v-card width="100%" tile  class="border-color: rgb(201, 76, 76)"> -->
      <v-layout row wrap>
          <v-col cols="12">
        
              <v-card flat width="100%" color="transparent" elevation="0" tile> 
            
                <v-col class="pb-0 pt-0" cols="12" v-for="(rec, i) in RegularcarsReservationData" :key="i+'a'" >  
                  <!-- <v-list :key="i+'b'"> 
                      {{rec.recs}}
                    </v-list>  -->
                    <template v-for="(r, a) in rec.recs">
                    <v-card :key="a+'t'" style="padding-top :0px; padding-bottom :0px" >                         
                        <v-toolbar window lights-out dense color="red lighten-3" style="padding-top:0px ; padding-bottom:0px ;">
                        <!-- <v-card> -->
                          <div>
                            <span class="mt-0 mb-0 mr-10" v-if="CheckDayCode(r.recs1[0].Day_Code)" style="color:red;font-family:Verdana;font-weight:bold;font-size:12px">[Coding Car] <br> </span>
                            <span class="mt-0 mb-0 mr-10" style = "color:black;font-family:Verdana;font-size:14px;font-weight:bold;padding-top:0px; padding-bottom:0px;">{{rec.timeDisplay}} </span>
                          </div>
                            
                        <!-- </v-card> -->
                              
                        <template v-if="r.recs1[0].designation !== 0">
                            <span class="mt-0 mb-0 mr-10" v-if="r.recs1[0].designation === 1"  style = "color:black;font-family:Verdana;font-size:13px;font-weight:bold;">Seaview -> NAIA</span>
                              <span class="mt-0 mb-0 mr-10" v-if="r.recs1[0].designation === 2"  style = "margin-top:5px;color:black;font-family:Verdana;font-size:13px;font-weight:bold;">Makati Only</span>
                          </template>

                        <v-row>
                          
                            
                          <template v-if="r.PlateNo !== 'null'">
                            <span class="mt-0 mb-0 mr-10"  style = "margin-top:4px;color:black;font-family:Verdana;font-size:13px;font-weight:bold;">{{r.PlateNo}} <br> ({{r.recs1[0].typeofCar}}) </span>
                          
                            <span class="mt-0 mb-0 mr-10"  style =  "margin-top:4px;color:black;font-family:Verdana;font-weight:bold;font-size:13px; ">Driver : {{r.recs1[0].Driver}} <br>
                            <span class="mt-0 mb-0 mr-10" style ="color:black;font-family:Verdana;font-size:13px;">Contact : {{r.recs1[0].driverContacts}}</span></span>
                          </template>
                          

                          <v-spacer></v-spacer>
          
                        
                        
                        </v-row>
                          <v-col  cols="2" > 
                        <v-btn v-if="r.PlateNo !== 'null'" @click="openDialogAssignReg(r.recs1)" x-small width="250"><span style="font-family:Verdana">Reassign</span> </v-btn>   
                        <v-btn v-else @click="openDialogAssignReg(r.recs1)" x-small width="250" color = "#F44336" dark > <span style="font-family:Verdana">Assign</span></v-btn>
                        <v-btn @click="transferReserved(r.recs1)" right x-small width="250" > <span style="font-family:Verdana">Transfer</span></v-btn>
                        </v-col>

                        </v-toolbar>                   
                        <v-card-text>                        
                          
                            <v-layout row  class="ma-0 pa-0" >
                            <template  v-for="(per, k) in r.recs1">
                              <v-tooltip top :key="k+'c'" color="grey darken-3" transition="slide-y-transition">
                                <template v-slot:activator = "{on}" >
                                  <v-chip draggable   small  class="body-1 black--text ma-1 " style = "color:black; font-family:Verdana;" 
                                  close             
                                    @click:close="cancelReservation(per.empId,per.EmpName)" v-on = "on">
                                          
                                  {{per.EmpName}} 

                                  </v-chip>
                                </template>
                                <span style="font-family:Verdana;color:white;font-weight:bold; text-align: justify">
                                  
                                  Fr : {{per.pickupName}}<br>
                                  <!-- To  : {{per.DropPointDetails }} -->
                                  To  : {{per.DropPointDetails ? per.DropPointDetails : per.DropPoint }}
                                </span>
                              </v-tooltip>
                            </template>  

                            <!-- <v-chip draggable v-for="(per, k) in r.recs1"  :key="k+'c'" small  class="body-1 black--text ma-1 " style = "color:black; font-family:Verdana;" 
                            close             
                              @click:close="cancelReservation(per.empId,per.EmpName)">
                                    
                            {{per.EmpName}} 

                            </v-chip> -->
                            <v-spacer></v-spacer>
                            <!-- {{r.recs1.length}} {{r.recs1[0]}} -->
                            <v-tooltip bottom>
                                <template v-slot:activator = "{on}">
                                    <v-btn  v-show="r.recs1.length < (r.recs1[0].capacity - 1) || r.recs1[0].capacity == null" fab x-small @click="openAddDialog(r.recs1,'regular')"  v-on = "on"> <v-icon>mdi-plus-thick</v-icon></v-btn>
                                </template>
                                      <span style="font-family:Verdana;color:white;font-weight:bold; text-align: justify">Add Employee Reservation</span>
                            </v-tooltip>
                    
                            
                          </v-layout>
                          
                          
                        </v-card-text>
                    
                        </v-card> 
                        </template>
                  </v-col>
                    
              </v-card>   
          </v-col> 
      </v-layout>
      <!-- Dialog for Regular Assignment -->
        <v-dialog v-model="DialogRegularAssign" persistent width="1000"  max-height="1000"> 
          <v-card height="100%">
        
          <v-toolbar dense color="red lighten-3">
                <v-toolbar-title style="font-family:Courier New;color:black;font-weight:bold">{{lblAssign}}</v-toolbar-title>
  
                <v-spacer></v-spacer>
                <v-icon>mdi-clock </v-icon>
                <span style="font-family:Courier New;color:black">{{timeDisplay}}</span>
                <v-spacer></v-spacer>
                <v-btn small icon @click="closeDialogAssignReg()" class="mr-0"><v-icon>mdi-close</v-icon></v-btn>
            </v-toolbar>
            
            
            <v-card :loading="loading" tile flat class="d-flex flex-row" height="100%" color="blue-grey darken-1">
            
            <v-card dark class="d-flex flex-column " color="blue-grey darken-1" tile height="100%" width="400">
            <v-simple-table dense>
                <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left">Employee Name</th>
                    <th class="text-left">Destination</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="item in remaining_list" :key="item.name">
                    <td>{{ item.EmpName }}</td>
                    <td>{{ item.DropPoint }}</td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
            
            </v-card>

              <v-card class="d-flex flex-column" color="transparent" tile height="100%" width="100%" >
                
<!-- for cars assign CARD                                   -->
          
              <v-form ref="form" v-model="valid1" :lazy-validation="lazy">
              <v-card class="d-flex flex-sm-row" v-for="(items,i) in newCard" :key="i+'z'"  color="blue-grey darken-1" dark>
              
                  <v-container fluid>
                  <v-row dense class="d-flex;" style="margin-bottom : -20px"  >
                    <v-col cols="3">
                      <v-combobox @change="selectPlateNo(plateNo[i])" 
                        outlined
                        :items="CarsList" 
                        label ="Plate Number"
                        v-model="plateNo[i]" 
                        clearable  dense
                        return-object  
                        item-text= 'plateNo'
                        item-value= "plateNo"
                        autocomplete="off"
                        required
                          :rules="[v => !!v || 'Plate number is required']"
                        >     
                        <template v-slot:selection="data">                   
                            {{ data.item.plateNo }}    
                            </template>   
                        <template v-slot:item="data">
                        <v-list-item-content v-text="data.item.plateNo + '  (' +data.item.codeDay +')'"></v-list-item-content>
                        </template>
                        </v-combobox> 
                    </v-col>
                    <v-col cols="5">
                        <v-combobox 
                        @change="selectLicense(selectedDriver[i])"
                        outlined
                        :items ="DriverList" 
                        label = "Driver"
                        v-model="selectedDriver[i]"
                        clearable  
                        dense
                        return-object  
                        item-text= 'DriverName'
                        item-value= "DriverName"
                        required
                          autocomplete="off"
                        :rules="[v => !!v || 'Driver is required']"
                        >
                        <template v-slot:selection="data">                   
                            {{ data.item.DriverName }}    
                            </template>   
                        <template v-slot:item="data">
                        <v-list-item-content v-text="data.item.DriverName"></v-list-item-content>
                        </template>
                      </v-combobox>  
                    </v-col>
                  <v-col cols="2">
                    <v-text-field v-model="capacity[i]" outlined label="Capacity" dense class="pa-0 ma-0 centered-input" readonly @input="enable()"></v-text-field>  
                  </v-col>
                  <v-col cols="2">
                    <v-text-field v-model="allocated[i]" outlined label="Allocated" dense class="pa-0 ma-0 centered-input" readonly ></v-text-field>  
                  </v-col>
                </v-row>
                  <v-row dense>
                    <v-radio-group row v-model="radiosAssign[i]" :mandatory="false" style="margin-bottom : -10px ; margin-top : 0px"> 
                    <span style="font-family:Verdana;color:white">Destination : </span>
                    
                    <v-radio label="ALL" value="0"></v-radio>
                    <v-radio label="Seaview -> NAIA" value="1"></v-radio>
                    <v-radio label="Makati Only" value="2"></v-radio>  
                    </v-radio-group>
                  </v-row>
              
                  <v-divider></v-divider>
                  <v-container>
                    <v-combobox
                    dark
                    v-model="selectedEmp[i]"
                    :items="availablePassengers"
                    :disabled="modellist[i]"
                    filled
                    dense
                    chips
                    
                    color="blue lighten-1"
                    label="Employee List"
                    item-text= 'EmpName'
                    item-value= "EmpName"
                    return-object
                    :counter="parseInt(capacity[i])"
                    multiple
                    @change="countval(items,selectedEmp[i])"
                    style="margin-bottom: -5px"
                    required
                    hide-selected
                    autocomplete="off"
                      :rules=" [ v => !!v || 'Employee is required',
                      v => (v && v.length <= parseInt(capacity[i])) || 'Employee must be less than or equal of Capacity of ' + capacity[i],
                      ]"
                      
                  >
                    <template v-slot:selection="data">
                      <v-chip
                        v-bind="data.attrs"
                        :input-value="data.selected"
                        close
                        @click="data.select"
                        @click:close="removeAssgnEmp(data.item,items)"
                      >
                      {{ data.item.EmpName }}
                      </v-chip>
                    </template>
                    <template v-slot:item="data">
                    <v-list-item-content>
                    <v-list-item-title v-text="data.item.EmpName"></v-list-item-title>
                  </v-list-item-content>                          
                </template>
              </v-combobox>
              </v-container>
              </v-container>
              </v-card>
                
<!-- add and save                             -->
                <v-card flat class="d-flex flex-row" color="blue-grey darken-1">
                  <v-container>
                    <v-layout>
                      
                    <v-spacer></v-spacer>
                    <v-btn  :disabled="!valid1" @click="SaveAssign()" dense rounded color="success"> <v-icon>mdi-content-save</v-icon>Save</v-btn>
                    <v-btn v-if="remaining_list.length !== 0" raised dense rounded color="indigo darken-1" dark @click="addCard()"><v-icon>mdi-car-door</v-icon>New Car</v-btn>
                    
                  </v-layout>

                  </v-container>
                
                
              </v-card>
              </v-form>
              </v-card>
            
              </v-card>
            
      </v-card>

    </v-dialog>
<!-- transfer Dialog -->
    <v-dialog v-model="transferDialog"  persistent width="350" >
                          
                          <v-card height="350">
                          
                            
                              <v-toolbar dense color="red lighten-3">
                                  <v-toolbar-title>Transfer Employee Assignment</v-toolbar-title>
                                  <v-spacer></v-spacer>
                                  <v-btn small icon @click="closeDialogTrans()" class="mr-0"><v-icon>mdi-close</v-icon></v-btn>
                              </v-toolbar>
                                <v-list-item three-line>
                                      <v-list-item-content>
                                        <!-- {{toAdd}} -->
                                      <v-list-item-subtitle>

                                    <v-select v-model="toAdd" 
                                      
                                      :items = "employeeListperTime" 
                                      dense outlined label = "Employee Name" 
                                      class="mt-2" required 
                                      return-object  
                                      item-text= 'EmpName'
                                      item-value= "EmpName"
                                        
                                      >
                                        <template v-slot:selection="data">
                                          
                                            {{ data.item.EmpName }}
                                        
                                            </template>
                                        
                                        <template v-slot:item="data">
                        
                                        <v-list-item-content v-text="data.item.EmpName"></v-list-item-content>
                  
                                        </template>
                                      </v-select>
                                      
                                        <v-text-field readonly v-model="timeDisplay" outlined dense label="Current Schedule" required></v-text-field>
                                      
                                        <v-select @change="selectTime(toLabel.ScheduleTime)" 
                                        outlined
                                        label = "Time Schedule" 
                                          
                                          :items="transTime" 
                                          v-model="toLabel.ScheduleTime" clearable dense 
                                          return-object  
                                              item-text= 'timeDisplay'
                                              item-value= "timeDisplay">
                                              <template v-slot:selection="data">   
                                                  {{ data.item.timeDisplay }}
                                              </template>
                                              <template v-slot:item="data">
                                              <v-list-item-content v-text="data.item.timeDisplay"></v-list-item-content>
                                              </template>
                                          
                                          </v-select> 
                                      
                                      
                                      
                                      </v-list-item-subtitle>
                                      <v-list-item>
                                            <v-btn @click="transferRes()"  color="success" block dense >Ok</v-btn>
                                      </v-list-item>
                                      
                                      </v-list-item-content>
                                </v-list-item>
                                
                                
                              </v-card> 
                                
                      </v-dialog>   
    </v-tab-item>
      <v-tab-item>
      <v-layout row wrap>
          <v-col cols="12">
              <v-card  flat width="100%" color="transparent"> 
                  <v-col class="pb-0 pt-0" cols="12" v-for="(rec, i) in SpecialcarsReservationData" :key="i+'a'" >
            <!-- Special Cars -->

              <template v-for="(r, a) in rec.recs">
                    <v-card :key="a+'t'" style="padding-top :0px; padding-bottom :0px" >                         
                        <v-toolbar max-height="60" height="50" window lights-out dense color="yellow lighten-3" style="padding-top:0px ; padding-bottom:0px ;">
                        <!-- <v-card> -->
                          <div>
                            <span class="mt-0 mb-0 mr-10" v-if="CheckDayCode(r.recs1[0].Day_Code)" style="color:red;font-family:Verdana;font-weight:bold;font-size:12px">[Coding Car] <br> </span>
                            <span  class="mt-0 mb-0 mr-8" style = "color:black;font-family:Verdana;font-size:14px;font-weight:bold;padding-top:0px; padding-bottom:0px;">{{rec.timeDisplay}} </span>
                          </div>

                          
                        <!-- </v-card> -->
                        

                          
                        <v-row>
                          <template v-if="r.PlateNo !== 'null'">
                            <span  class = "mr-8 " style = "color:black;font-family:Verdana;font-size:13px;font-weight:bold;">{{r.PlateNo}} <br> ({{r.recs1[0].typeofCar}}) </span>
                            <span class = "mr-8" style =  "color:black;font-family:Verdana;font-weight:bold;font-size:13px; ">Driver : {{r.recs1[0].Driver}} <br>
                            <span style ="color:black;font-family:Verdana;font-size:13px;">Contact : {{r.recs1[0].driverContacts}}</span></span>
                          </template>
                          <span style =  "color:black;font-family:Verdana;font-size:13px;font-weight:bold; ">Reserved by : {{r.recs1[0].R_Name}} <br>
                          <span v-if="!r.recs1[0].EventVenue" style ="color:black;font-family:Verdana;font-size:12px;">
                            <span v-if="r.recs1[0].Remarks !== 'Others'" >Purpose : {{r.recs1[0].Remarks}} / {{r.recs1[0].DropPoint}} </span>
                            <span v-else> Purpose : {{r.recs1[0].Remarks}} - {{r.recs1[0].OtherRemarks}} / {{r.recs1[0].DropPoint}}</span>
                            </span>
                          <span v-else style ="color:black;font-family:Verdana;font-size:12px;">Purpose : {{r.recs1[0].Remarks}} / {{r.recs1[0].EventVenue}} /{{r.recs1[0].DropPoint}} </span></span>
                        </v-row>
                          <v-spacer></v-spacer>
          
                        <template> 
                        <v-btn @click="openDialogAssignSpecial(r.recs1)" small  v-if="r.PlateNo !== 'null'">
                          <span style="font-family:Verdana;font-size:9px"> Reassign</span>
                          
                          </v-btn>
                          <v-btn @click="openDialogAssignSpecial(r.recs1)" small v-else color = "#F44336" dark >
                          <span  >Assign</span>
                          </v-btn>
                      
                        </template>
                        
                        
                      
                        </v-toolbar>                   
                        <v-card-text>                        
                        
                            <v-layout row  class="ma-0 pa-0" >
                              <template  v-for="(per, k) in r.recs1">
                              <v-tooltip top :key="k+'c'" color="grey darken-3" transition="slide-y-transition">
                                <template v-slot:activator = "{on}" >
                                  <v-chip draggable   small  class="body-1 black--text ma-1 " style = "color:black; font-family:Verdana;" 
                                  close             
                                    @click:close="cancelReservation(per.empId,per.EmpName)" v-on = "on">
                                          
                                  {{per.EmpName}} 

                                  </v-chip>
                                </template>
                                <span style="font-family:Verdana;color:white;font-weight:bold; text-align: justify">
                                  
                                  Fr : {{per.pickupName}}<br>
                                  To  : {{ per.DropPointDetails ? per.DropPointDetails : per.DropPoint}}
                                  
                                </span>
                              </v-tooltip>
                            </template>
                            <!-- <v-chip v-for="(per, k) in r.recs1"  :key="k+'c'" small  class="body-1 black--text ma-1 " style = "color:black; font-family:Verdana;" 
                            close             
                              @click:close="cancelReservation(per.empId,per.EmpName)">
                                    
                            {{per.EmpName}} 

                            </v-chip> -->
                              <v-spacer></v-spacer>
                          <v-tooltip bottom>
                                <template v-slot:activator = "{on}">
                                    <v-btn  v-if="r.recs1.length < (r.recs1[0].capacity - 1) || r.recs1.length < 5" fab x-small @click="openAddDialog(r.recs1,'special')"  v-on = "on"> <v-icon>mdi-plus-thick</v-icon></v-btn>
                                </template>
                                      <span style="font-family:Verdana;color:white;font-weight:bold; text-align: justify">Add Employee Reservation</span>
                            </v-tooltip>
                            
                          </v-layout>
                        </v-card-text>
                    
                        </v-card> 
                        </template>


        
                
                  </v-col>
              </v-card>           
          </v-col>
      </v-layout>
      <!-- Dialog for Special Assignment                          -->
                      <v-dialog v-model="DialogSpecialAssign" persistent width="1000"  max-height="1000"> 
                            <v-card height="100%" >
                          <!-- availablePassengers: {{availablePassengers}}
                          <hr> -->
                          <!-- selectedEmp : {{selectedEmp}} -->
                        <v-toolbar dense color="yellow lighten-3">
                                  <v-toolbar-title style="font-family:Courier New;color:black;font-weight:bold">{{lblAssign}}</v-toolbar-title>
                    
                                  <v-spacer></v-spacer>
                                  <v-icon>mdi-clock </v-icon>
                                  <span style="font-family:Courier New;color:black">{{timeDisplay}}</span>
                                  <v-spacer></v-spacer>
                                  <v-btn small icon @click="closeDialogAssignReg()" class="mr-0"><v-icon>mdi-close</v-icon></v-btn>
                              </v-toolbar>
                              
                              
                              <v-card   tile flat class="d-flex flex-row" height="100%" color="blue-grey darken-1">
                              
                              <v-card dark class="d-flex flex-column " color="blue-grey darken-1" tile height="100%" width="400">
                              <v-simple-table dense>
                                  <template v-slot:default>
                                  <thead>
                                    <tr>
                                      <th class="text-left">Employee Name</th>
                                      <th class="text-left">Destination</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    <tr v-for="item in remaining_list" :key="item.name">
                                      <td>{{ item.EmpName }}</td>
                                      <td>{{ item.DropPoint }}</td>
                                    </tr>
                                  </tbody>
                                </template>
                              </v-simple-table>
                              <!-- <pre>{{selectEmpName}}</pre> -->
                              <!-- <pre>{{ListReserved}}</pre> -->
                              
                              </v-card>

                                <v-card class="d-flex flex-column" color="transparent" tile height="100%" width="100%" >
                                  
<!-- for cars assign CARD                                   -->
                            
                                <v-form ref="form" v-model="valid1" :lazy-validation="lazy">
                                <v-card :loading="loading" class="d-flex flex-sm-row" v-for="(items,i) in newCard" :key="i+'z'"  color="blue-grey darken-1" dark>
                                <!-- {{ListReserved[i]}} -->
                                    <v-container fluid>
                                    <v-row dense class="d-flex;" style="margin-bottom : -20px"  >
                                      <v-col cols="3">
                                        <v-combobox @change="selectPlateNo(plateNo[i])" 
                                          outlined
                                          :items="CarsList" 
                                          label ="Plate Number"
                                          v-model="plateNo[i]" 
                                          clearable  dense
                                          return-object  
                                          item-text= 'plateNo'
                                          item-value= "plateNo"
                                          required
                                            autocomplete="off"
                                            :rules="[v => !!v || 'Plate number is required']"
                                          >     
                                          <template v-slot:selection="data">                   
                                              {{ data.item.plateNo }}    
                                              </template>   
                                          <template v-slot:item="data">
                                          <v-list-item-content v-text="data.item.plateNo + '  (' + data.item.codeDay +')'"></v-list-item-content>
                                          </template>
                                          </v-combobox> 
                                      </v-col>
                                      <v-col cols="5">
                                          <v-combobox 
                                          @change="selectLicense(selectedDriver[i])"
                                          outlined
                                          :items ="DriverList" 
                                          label = "Driver"
                                          v-model="selectedDriver[i]"
                                          clearable  
                                          dense
                                            autocomplete="off"
                                          return-object  
                                          item-text= 'DriverName'
                                          item-value= "DriverName"
                                          required
                                          :rules="[v => !!v || 'Driver is required']"
                                          >
                                          <template v-slot:selection="data">                   
                                              {{ data.item.DriverName }}    
                                              </template>   
                                          <template v-slot:item="data">
                                          <v-list-item-content v-text="data.item.DriverName"></v-list-item-content>
                                          </template>
                                        </v-combobox>  
                                      </v-col>
                                    <v-col cols="2">
                                      <v-text-field v-model="capacity[i]" outlined label="Capacity" dense class="pa-0 ma-0 centered-input" readonly @input="enable()"></v-text-field>  
                                    </v-col>
                                    <v-col cols="2">
                                      <v-text-field v-model="allocated[i]" outlined label="Allocated" dense class="pa-0 ma-0 centered-input" readonly ></v-text-field>  
                                    </v-col>
                                  </v-row>
                                    
                                
                                    <v-divider></v-divider>
                                    <v-container>
                                      <v-combobox
                                      dark
                                      v-model="selectedEmp[i]"
                                      :items="availablePassengers"
                                      :disabled="modellist[i]"
                                      filled
                                      dense
                                      readonly
                                      chips
                                      hide-selected
                                      color="blue lighten-1"
                                      label="Employee List"
                                      item-text= 'EmpName'
                                      item-value= "EmpName"
                                      return-object
                                      :counter="parseInt(capacity[i])"
                                      multiple
                                      @change="countval(items,selectedEmp[i])"
                                      style="margin-bottom: -5px"
                                      required
                                      
                                      autocomplete="off"
                                        :rules=" [ v => !![] || 'Employee is required',
                                        v => !!v || 'Employee is required',
                  
                                        ]"
                                        
                                    >
                                      <template v-slot:selection="data">
                                        <v-chip
                                          v-bind="data.attrs"
                                          :input-value="data.selected"
                                          
                                        >
                                        {{ data.item.EmpName }}
                                        </v-chip>
                                      

                                      </template>
                                      <template v-slot:item="data">
                                      <v-list-item-content>
                                      <v-list-item-title v-text="data.item.EmpName"></v-list-item-title>
                                    </v-list-item-content>                          
                                  </template>
                                </v-combobox>
                                </v-container>
                                </v-container>
                                </v-card>
                                  
  <!-- add and save                             -->
                                  <v-card flat class="d-flex flex-row" color="blue-grey darken-1">
                                    <v-container>
                                      <v-layout>
                                        
                                      <v-spacer></v-spacer>
                                      <v-btn  :disabled="!valid1" @click="SaveAssign()" dense rounded color="success"> <v-icon>mdi-content-save</v-icon>Save</v-btn>
                                      <!-- <v-btn v-if="lblAssign === 'Car Assignment'" raised dense rounded color="indigo darken-1" dark @click="addCard()"><v-icon>mdi-car-door</v-icon>New Car</v-btn> -->
                                      
                                    </v-layout>

                                    </v-container>
                                  
                                  
                                </v-card>
                                </v-form>
                                </v-card>
                              
                                </v-card>
                              
                        </v-card>

                        </v-dialog>
      </v-tab-item>
    </v-tabs-items>
    <v-layout>
      <v-spacer></v-spacer>
        <v-btn color="success" :dark="RegularwithoutPlateNo == 0 && SpecialwithoutPlateNo == 0" :disabled="(RegularwithoutPlateNo !== 0 || SpecialwithoutPlateNo !== 0) || (RegularcarsReservationData.length === 0 && SpecialcarsReservationData.length === 0)" @click="FinishAssign()" v-if="FinishData.SelectUse == 'False'">
      Finish
    </v-btn>
    <v-btn color="red" dark @click="FinishAssign()" v-else>
      Cancel
    </v-btn>
    <!-- </back-to-top> -->
    
    </v-layout>
    

    <v-container fluid>
      <v-dialog v-model="addDialog" persistent width="350">
        <v-card height="370px">
          <v-toolbar dense color="#213c57" dark> <v-icon>mdi-calendar-clock</v-icon>
          <span style = "font-family: Verdana;font-size:15px">Additional Employee Reservation </span>

          <v-spacer></v-spacer>
            <v-btn icon @click="closeAddDialog()"><v-icon>mdi-close</v-icon></v-btn>
        </v-toolbar>
              
          
          <v-container fluid>
            <!-- {{toAdd}} -->
            <v-list-item-title v-model="toAdd.timeDisplay" class="headline mb-2 mt-0 text-center"  >{{toAdd.timeDisplay}}</v-list-item-title>
            <v-form
              ref="formAdd"
            v-model="validAdd"
              >
                <v-card height="190"  flat style = "border: 1px solid grey">
                  <v-container fluid>
                  
                    
                    <v-select @change="selectedAdd(toLabel.name)" 
                      
                        :items = "employeelistR" 
                        required
                        :rules="[v => !!v || 'Employee Name is required']"
                        label = "Employee Name"
                        v-model="toLabel.name" clearable  dense
                        return-object  
                        item-text= 'EmpName'
                        item-value= "EmpName"
                          autocomplete="off">
                        
                        <template v-slot:selection="data">   
                            {{ data.item.EmpName }}
                        </template>
                        <template v-slot:item="data">
                        <v-list-item-content v-text="data.item.EmpName"></v-list-item-content>
                        </template>
                    </v-select>
                    
                      
                    <v-select @change="selectPickUpName(toAdd.pickupName)" 
                      autocomplete="off"  label = "Pickup Point" 
                      :items="PickupList"  v-model="toAdd.pickupName" clearable dense 
                      required :rules="[v => !!v || 'Pickup Point is required']"></v-select>
                    
                    <v-select @change="selectDropName(toAdd.DropPoint)" 
                      autocomplete="off"  label = "Drop Point" 
                      :items="DropPointList" v-model="toAdd.DropPoint" clearable dense 
                      required :rules="[v => !!v || 'Drop Point is required']"></v-select>
                  
                  </v-container>
                </v-card>
              </v-form>
              <v-card-text>
                <v-layout>
                <v-spacer></v-spacer>         
                <v-btn :disabled="!validAdd" @click="AdditionalReservation()" color="success">Add Reservation</v-btn>
                <v-spacer></v-spacer>
              </v-layout>

              </v-card-text>
              
              </v-container>
            
        </v-card>
      </v-dialog>

    </v-container>
    

  <v-container fluid>
    <v-dialog v-model="dialog" persistent width="700">
  
    <v-card max-height="820px">
        <v-toolbar dense color="#213c57" dark> <v-icon>mdi-calendar-clock</v-icon>
          <span style = "font-family: Verdana;font-size:15px"> Schedule Employee</span>

          <v-spacer></v-spacer>
            <v-btn icon @click = "closeDialog()"><v-icon>mdi-close</v-icon></v-btn>
        </v-toolbar>
        <v-card-text >
          
          <v-container fluid>
            
                <v-card height="200"  flat style = "border: 1px solid grey">
                  <v-container fluid>
                    <v-radio-group v-model="radios" :mandatory="false">
                    <v-radio @change="test()" label="Regular" value="radio-1"></v-radio>
                    <!-- <v-radio label="Radio 2" value="radio-2"></v-radio> -->
                    </v-radio-group>
                    <v-form
              ref="form1"
            v-model="valid"
            
              >
                    <v-row style="margin-top :-25px">
                      <v-col>
                    <v-combobox @change="selectEmpDataR(toLabel.name)" 
                        :disabled ="isRegular"
                        :items = "employeelistR" 
                        required
                        :rules="[v => !!v || 'Employee Name is required']"
                        label = "Employee Name"
                        v-model="toLabel.name" clearable  dense
                        return-object  
                        item-text= 'EmpName'
                        item-value= "EmpName"
                          autocomplete="off">
                        
                        <template v-slot:selection="data">   
                            {{ data.item.EmpName }}
                        </template>
                        <template v-slot:item="data">
                        <v-list-item-content v-text="data.item.EmpName"></v-list-item-content>
                        </template>
                    </v-combobox>
                    <v-select @change="selectTime(toLabel.ScheduleTime)" 
              
                    :disabled = "isRegular" label = "Time Schedule" 
                    :items="ScheduleTime" 
                    required
                    :rules="[v => !!v || 'Time Schedule is required']"
                    v-model="toLabel.ScheduleTime" clearable dense 
                    return-object  
                        item-text= 'timeDisplay'
                        item-value= "timeDisplay">
                          <template v-slot:selection="data">   
                            {{ data.item.timeDisplay }}
                        </template>
                        <template v-slot:item="data">
                        <v-list-item-content v-text="data.item.timeDisplay"></v-list-item-content>
                        </template>
                    
                    </v-select>
                      </v-col>
                      <v-col>
                    <v-select @change="selectPickUpName(toAdd.pickupName)" 
                      autocomplete="off" :disabled = "isRegular" label = "Pickup Point" 
                      :items="PickupList"  v-model="toAdd.pickupName" clearable dense 
                      required :rules="[v => !!v || 'Pickup Point is required']"></v-select>
                    <v-select @change="selectDropName(toAdd.DropPoint)" 
                      autocomplete="off" :disabled = "isRegular" label = "Drop Point" 
                      :items="DropPointList" v-model="toAdd.DropPoint" clearable dense 
                      required :rules="[v => !!v || 'Drop Point is required']"></v-select>
                    </v-col>
                    </v-row>
                    </v-form>
                  </v-container>
                  
                </v-card>
              

  <!-- /////////////Special Reservation -->
      
          
                <v-card  :max-height = "500"  flat style = "border: 1px solid grey">

                  <v-container fluid>
                        
                    <v-radio-group v-model="radios" :mandatory="false">
                    <v-radio @change="test()" label="Special" value="radio-2"></v-radio>
                    <!-- <v-radio label="Radio 2" value="radio-2"></v-radio> -->
                    </v-radio-group>
                    <v-form
                    ref="form2"
                    v-model="valid2" 
                    >
                    <v-row style="margin-top : -25px">
                      <v-col>
                    <v-combobox @change="selectEmpDataS(toLabel.names)" 
                        :disabled = "isSpecial"
                        :items = "employeelistR" 
                          required
                        :rules="[v => !!v || 'Employee Name is required']"
                        label = "Reserved by"
                        v-model="toLabel.names" clearable  dense
                        return-object  
                        item-text= 'EmpName'
                        item-value= "EmpName"
                          autocomplete="off">
                        <template v-slot:selection="data">                   
                            {{ data.item.EmpName }}    
                            </template>   
                        <template v-slot:item="data">
                        <v-list-item-content v-text="data.item.EmpName"></v-list-item-content>
                        </template>
                    </v-combobox>
                      <v-select @change="selectTimeS(toLabel.ScheduleTimeS)" 
                    :disabled = "isSpecial" label = "Time Schedule" 
                        required
                    :rules="[v => !!v || 'Time Schedule is required']"
                    :items="ScheduleTimeS" 
                    v-model="toLabel.ScheduleTimeS" clearable dense 
                    return-object  
                        item-text= 'timeDisplay'
                        item-value= "timeDisplay">
                          <template v-slot:selection="data">   
                            {{ data.item.timeDisplay }}
                        </template>
                        <template v-slot:item="data">
                        <v-list-item-content v-text="data.item.timeDisplay"></v-list-item-content>
                        </template>
                    
                    </v-select>                  
                      
                    </v-col>
                    <v-col>
                    <v-combobox @change="selectPickUpName(toAddS.pickupName)"  autocomplete="off"
                      :disabled = "isSpecial" label = "Pickup Point" :items="PickupList" 
                      clearable dense v-model="toAddS.pickupName"
                      required :rules="[v => !!v || 'Pickup Point is required']" ></v-combobox>
                    <!-- <v-text-field  label = "Drop Point"  clearable dense  autocomplete="off" 
                    v-model="toAddS.DropPoint " :disabled = "isSpecial"
                    required :rules="[v => !!v || 'Drop Point is required']"></v-text-field> -->
                    <v-select @change="selectDropName(toAddS.DropPoint)" 
                      autocomplete="off"  :disabled = "isSpecial"
                      :items="DropPointList" v-model="toAddS.DropPoint" clearable dense :label = "$t('cars.dropPoint')"
                      required :rules="[v => !!v || 'Drop Point is required']"></v-select>
                    </v-col>
                    
                    </v-row>
                      <v-row  style="margin-top: -30px">
                      <v-col  >
                        <v-select  :disabled = "isSpecial"  @change="cleartext()" v-model="toAddS.TypeRequest" label="Select type" :items="TypeRequest">
                        </v-select>
                      </v-col>
                      <v-col >
                        <v-select  :disabled = "isSpecial"  :label = "$t('cars.purpose')" v-model="toAddS.Remarks"  required :rules="rule3" :items="toAddS.TypeRequest ==  'Business Use' ? BusinessUse : NotBusiness"> </v-select>
                      </v-col>
                      <v-col v-if="toAddS.TypeRequest == 'Business Use' ? true : false" >
                        
                        
                        <v-select  :disabled = "isSpecial"  
                        :label = "$t('cars.eventVenue')" 
                        v-model="toAddS.EventVenue"  required 
                        :rules="[v => !!v || 'Event Venue is required']" 
                        :items="EventVenue"
                        :items-text="EventVenue.text"
                          :hint="toAddS.EventVenue == 'Cavite' ? CaviteMsg : '' "
                        persistent-hint
                        > </v-select>
                    
                    
                      </v-col>
                      <v-col v-if="toAddS.Remarks == 'Others' ? true : false">
                          <v-text-field label="Remarks" v-model="toAddS.OtherRemarks"></v-text-field>
                      </v-col>
                    </v-row>

                  
                    <v-combobox
                      v-model="Members"
                      :items="employeeList"
                      filled
                      dense
                      chips
                      clearable
                      color="blue-grey lighten-2"
                      label="Member List"
                      item-text= 'EmpName'
                      item-value= "EmpName"
                      return-object
                      autocomplete="off"
                      :disabled = "isSpecial"
                      multiple
                      :hint="toAddS.TypeRequest == 'Not Business Use' ? 'Need to add atleast 1 Member' : 'Maximum of 5 Members' "
                      persistent-hint
                      counter="5"
                    >
                      <template v-slot:selection="data">
                        <v-chip
                          v-bind="data.attrs"
                          :input-value="data.selected"
                          color="yellow lighten-3"
                          close
                          @click="data.select"
                          @click:close="remove(data.item.empId)"
                        >
                          <!-- <v-avatar left>
                            <v-img :src="data.item.avatar"></v-img>
                          </v-avatar> -->
                          {{ data.item.EmpName }}
                        </v-chip>
                      </template>

                      <template v-slot:item="data">
                          <v-list-item-content>
                            <v-list-item-title v-text="data.item.EmpName"></v-list-item-title>
          
                          </v-list-item-content>                          
                      </template>
                      </v-combobox>
                        </v-form>
                  </v-container>
                </v-card>
              
          
          </v-container>
          <v-layout>
            <v-spacer></v-spacer>
              <v-btn v-if="toAddS.TypeRequest === 'Not Business Use'" @click="AddReserved()" :disabled="validate || Members.length === 0? true : false" color="success">Add Reservation</v-btn>  
                          
        <v-btn v-else :disabled="validate" @click="AddReserved()" color="success">Add Reservation</v-btn>
        <v-spacer></v-spacer>
        </v-layout>
        </v-card-text>
        
    </v-card>
    </v-dialog>


  </v-container>
<!-- </v-card> -->


</v-container> 
<v-snackbar v-model="snackbar" :timeout="3000" bottom right  color = "#298f41">  
          <span style = "font-family:Verdana"> reservation has been cancel </span>
      </v-snackbar>
</div>
</template>

<script>
import moment from 'moment-timezone'
// import axios from 'axios'
import _ from 'lodash'
import swal from 'sweetalert'
import { mask } from 'vue-the-mask'
import api from '../api'

// import { mapState , mapActions, mapGetters} from 'vuex'
export default {
  directives: {
    mask,
  },
components: {

},
data(){
  
  return{

    isSetting: false,
    dateToday: moment().format("YYYY-MM-DD"),
    // dateToday : '2020-11-06',
    dayToday: moment().format('dddd'),
    plateNo: [],
    allocated: [],
    capacity: [],
    forAdd: [],
    timeToday: '',
    timeDisplay: '',
    dialog: false,
    transferDialog: false,
    addDialog : false,
    toAdd :{},
    toAddS:{},
    toLabel :{},
    btnName : '',
    userList:[],
    employeelistR:[],
    employeeList:[],
    ScheduleTime: [],
    ScheduleTimeS: [],
    PickupList:[],
    DropPointList:[],
    userListID: [],
    employeeListperTime: [],
    fullName: '',
    idNum:'',
    radios: 'radio-1',
    radiosAssign : [],
    timeID: '',
    timeIDlist: {},
    isRegular: false,
    isSpecial : true,
    RegularcarsReservationData: [],
    RegularwithoutPlateNo: 0,
    SpecialwithoutPlateNo: 0,
    SpecialcarsReservationData: [],
    listofIDreserved : [],   
    autoUpdate: true,
    tabs : null,  
    isUpdating: false,
    snackbar: false,
    switch1 : false,
    autoSwitch : true,
    CarswithReserved :[],
    listofRegularRes : [],
    valid : true,
    Members :[],
    transferMem : {},
    transTime: [],
    MembersList: [],
    DialogRegularAssign: false,
    DialogSpecialAssign: false,
    DriverList : [],
    CarsList: [],
    CarslistArray:[],
    ListReserved : [],
    ListReserved2: [],
    ListofEmpReserved: [],
    ListofEmpRes: [],
    ListofEmpResarvation: [],
    selectedEmp:[],
    capac : false,
    modellist : [],
    licenseNo : '',
    Driver : {},
    DriverName : '',
    selectedDriver : [],
    details:[],
    driverdetails : {},
    cartypeof : '',
    specialRequest : false,
    newCard : ['Card0'],
    counter : 0,
    valid1: true,
    lazy: false,
    lblAssign : '',
    selectedPlateNumber : [],
    selectEmpName : [],
    listId : [], 
    validAdd : true,
    isLoading: false, // 2026-04-16
    loading : false,
    valid2 : true,
    rule3 : [v => !!v || 'Purpose is required'],
    TypeRequest : ['Business Use','Not Business Use'],
          
    BusinessUse: ['Local Fellowship','Dinner with supplier', 'Meeting with guest', 'Overtime'],
    NotBusiness: ['Dinner','Sports','Others'],
    EventVenue: [{ id : '1', text :'Cavite', content : 'Color coding service is prioritized to assign. You may leave Cavite area after 7:45'},
                {id : '2', text : 'Not Cavite', content : '' }],
    CaviteMsg : 'Color coding service is prioritized to assign. It may leave Cavite area after 19:45',

    toEditTime : {},
    timeData : [],
    timeCutoff : '',
    timeFinish :'',
    mask: '##:##',
    ListofNull :[],
    listDialog : false,
    listofPresent : [],
    ListofEmpWithoutRes :[],
    groupByPlateNo : [],
    FinishData : {},
    DataFinish : [],
    remarksDialog : false,
    vRemarks : {},
    validRemarks : true,
    btnRemarks : 'Add',
    vRemarksSwitch : false,
    lblremarksSwitch : '',
    notedRemarks : '',
    CarsTypeList : []
    }
  
},
computed:{
      AllCount(){
        return this.$store.getters.CountSpecial + this.$store.getters.CountReg
      },
      availablePassengers() {
        if(this.selectedEmp.length > 0){
          let passengerOk = this.selectedEmp.reduce((a,b) => {
            return a.concat(b) 
          }, [])
          return this.ListReserved.filter( rec => {
            return !passengerOk.includes(rec)
          })
        }else{
          return this.ListReserved
        }
      },
      countAllocated(){
        return this.selectedEmp.length
      },
      remaining_list(){
        return this.ListofEmpReserved.filter(r =>{
          return !this.selectEmpName.includes(r.empId)
        })

      },
    lblLock(){
      if(this.switch1 == false){
        return 'Reservation is Unlock'
      }else{
        return 'Reservation is Lock'
      }
    },
    lblautolock(){
      if(this.autoSwitch == false){
        return 'Auto Lock is OFF'
      }else{
        return 'Auto Lock is ON'
      }
    },

    validate(){
      if(this.radios === 'radio-1'){
        return !this.valid 
      }else if (this.radios === 'radio-2'){
        return !this.valid2
      }else{
        return this.valid
      }
    },
},

created(){
  
  this.loadSchedule()
  this.loadDropPoint()
  this.loadPickUpPoint()

  this.loadData()
  this.CarswithReserved_Promise()
  this.loadCarsList()
  this.loadDriverList()
  
  this.loadAllReservation()
  this.loadEmpList()
  this.loadcutOff()
    
  // this.$EventBus.$on('SendCarUpdate',()=>{  
  //     this.loadAllReservation()
  //     this.loadCarsList()
  //     this.loadDriverList()
  //     this.loadData()
  //     this.loadRemarks()
  //     this.$store.dispatch('LOAD_COUNT', { dateToday :this.dateToday })
  //  })

  this.$socket.on('cars_update',()=>{   // 2026-04-17
      this.loadAllReservation()
      this.loadCarsList()
      this.loadDriverList()
      this.loadData()
      this.loadRemarks()
      this.$store.dispatch('LOAD_COUNT', { dateToday :this.dateToday })
   })


  setTimeout(() => {
    this.loadFinishData()
  }, 1000);

  this.loadRemarks()
  this.loadCarTypeList()
  
},
  watch: {
  
    capacity(val){
      let index = this.newCard.indexOf(val)
      if (this.val !== 0){
        
        this.modellist[index] = false
      }else{
        this.modellist[index] = true
      
      }
    },

    details(val){
      if(val === 0){
        this.selectedDriver = []
        this.selectedDriver = ''
      }
    },
    '$i18n.locale'(val){
      if(val == 'en'){
        this.notedRemarks = this.vRemarks.Eng
      }else{
        this.notedRemarks = this.vRemarks.Jap
      }
    }
  },

methods:{

  loadRemarks(){
    let url = `${this.api}getRemarks`
    api.get(url).then(res =>{
      if(res.data){
        this.vRemarks.id = res.data[0].id
        this.vRemarks.Eng = res.data[0].Eng
        this.vRemarks.Jap = res.data[0].Jap
        this.vRemarksSwitch= res.data[0].switch
        this.btnRemarks = 'Update'
        if(this.vRemarksSwitch == false){
          this.notedRemarks = ''
        }else{
          if( this.$i18n && this.$i18n.locale == 'en'){
            this.notedRemarks = res.data[0].Eng
          }else{
              this.notedRemarks = res.data[0].Jap
          }
        }
      }else{
        this.btnRemarks = 'Add'
        this.vRemarks = {} 
      }     
    })
  },
  OpenRemarks(){
    this.loadRemarks()
   
    this.remarksDialog = true
  },
  CheckDayCode(val){
    if(val){
      // console.log(val)
      if(moment().format('dddd') == val){
        return true
      }else{
        return false
      }
    }else{
      return false
    }
  },
  async FinishAssign() {  // 2026-05-14
    // Toggle
    this.FinishData.SelectUse = this.FinishData.SelectUse === 'True' ? 'False' : 'True';
    
    try {
      const url = `${this.api}updateDropOff`;
      const res = await api.put(url, this.FinishData);
      this.$socket.emit('cars_update', res.data);
    } catch (error) {
      console.error("Failed to update:", error);
    }
  },
  // FinishAssign(){
  //   if(this.FinishData.SelectUse == 'True'){
  //     this.FinishData.SelectUse = 'False'
  //     let url = `${this.api}updateDropOff`
  //     api.put(url, this.FinishData).then(res =>{
  //         this.$socket.emit('cars_update', res.data )
  //     })
  //   }else{
  //     this.FinishData.SelectUse = 'True'
  //     let url = `${this.api}updateDropOff`
  //     api.put(url, this.FinishData).then(res =>{
  //       this.$socket.emit('cars_update', res.data )
  //     })
  //   }
  // },
  loadFinishData(){
      let url = `${this.api}getDropPoint`
      api.get(url).then (res => {
        let fData = res.data.filter(r =>{
          return r.pointID == '000001DONE'
        })
        if(fData[0].PointName !== this.dateToday){
          let dataF = {
              pointID : '000001DONE',
              PointName : this.dateToday,
              SelectUse :  'False'
          }
            let url = `${this.api}updateDropOff`
          api.put(url,dataF).then(res =>{
            this.FinishData = dataF
          console.log(res.data)
          })
        }
        else{
          this.FinishData = fData[0]
        }
        // console.log(this.FinishData)
        
      })
    },

  getPresentUser(){
    let url = `${this.api}getLogDateAllEmployee/${this.dateToday}`
    api.get(url).then(res =>{
      
      this.listofPresent = res.data.filter(rec =>{
        return rec.attendance == 'RPT' || rec.attendance == 'HD'
      }).map(r1 =>{
        return {empId : r1.employee,
                empName : r1.empnameEng }
      })
    })
  },

  getPresentUser_Promise(){
      return new Promise((resolve) => {
        let url = `${this.api}getLogDateAllEmployee/${this.dateToday}`
        api.get(url).then(res =>{
          
          this.listofPresent = res.data.filter(rec =>{
            return rec.attendance == 'RPT' || rec.attendance == 'HD'
          }).map(r1 =>{
            return {empId : r1.employee,
                    empName : r1.empnameEng }
          })
        })

        resolve(this.listofPresent)
        
      })
  },

  loadEmpList_Promise(){   // Employees in Soumu
      return new Promise ((resolve) => {
          let url =  `${this.api}getUserswithCars`
          api.get(url).then(res =>{         
        this.employeelistR = _.orderBy(res.data, ['LastNameEng'], ['ASC']).filter( rec1 => {
          return !this.listofIDreserved.includes(rec1.id) && rec1.id !== this.userData.id
        }).map(rec2 => {
            return {EmpName: rec2.LastNameEng + ', ' + rec2.FirstNameEng,
                    empId : rec2.id, localNumber : rec2.localNumber,
                    DropPoint: rec2.DropPoint, pickupName: rec2.PickUpPoint,
                      }
        })    
        resolve(this.employeelistR)     
      })

      })
  },

  async openlistDialogPromise(){
    try{
      const presentUser_response = await this.getPresentUser_Promise();
      const loadEmpList_Promise = await this.loadEmpList_Promise();


    this.ListofEmpWithoutRes = presentUser_response.filter(r2=>{
          return  loadEmpList_Promise.map(rec=>{
            return rec.empId
          }).includes(r2.empId)
      })

      // console.log('line1503', this.ListofEmpWithoutRes)

        this.listDialog = true
    }catch(err) {
      console.log(err)
    }
  },

  closelistDialog(){
    this.listDialog = false
    this.ListofEmpWithoutRes = []
  },

  testFormat(val){
      //timein
        // mask: '##:##:##'      
      // if ( this.showTimeIn === 1) 
      // setTimeout(() => {
        if ( val.length === 5) {
              this.mask = '##:##' 
          } else if ( val.length === 4) {
            //  this.mask = '0#:##:00'    
              this.mask = '0#:##'          
        }
      // }, 700);               
    },

  // setcutOff(){ // tanskie
      
  //     if(this.timeCutoff.length < 5 || this.timeFinish.length < 5 ){
  //       swal({title : 'Please Input correct time format '})
  //      }else{
  //         let url = `${this.api}updatecarType`
  //         this.toEditTime.id = '000001' 
  //         this.toEditTime.capacity = this.timeCutoff +':00' + this.timeFinish +':00'   
  //         console.log(' this.toEditTime.capacity',  this.toEditTime.capacity)   
  //         // console.log(this.toEditTime)
  //         if(this.switch1 == false){
  //           this.toEditTime.cartype = 'false'
  //         }else{
  //           this.toEditTime.cartype = 'true'
  //     }
  //       api.put(url,this.toEditTime).then (res =>{
  //               console.log(res.data) 
  //               this.loadcutOff()
  //               let msgTitle = "Save"
  //               swal( msgTitle, " " , "success" , {
  //               timer: 1000,
  //               button:false
  //           })

  //       })
  //     }
  //   },

    // ReservedLock(){
    //   let url = `${this.api}updatecarType`
    //   this.toEditTime.id = '000001' 
    //   this.toEditTime.capacity = this.timeCutoff+':00' + this.timeFinish + ':00' 
    //   if(this.switch1 === false){
    //     this.toEditTime.cartype = 'false'
    //   }else{
    //     this.toEditTime.cartype = 'true'
    //   }
    //   setTimeout(() => {
    //       api.put(url,this.toEditTime).then (res =>{
    //             console.log(res.data) 
    //             this.$socket.emit('cars_update', this.toEditTime )
    //     })
    //    }, 3000);
    // },

    ReservedLock(){
      this.isSetting = true ;
      let url = `${this.api}updatecarType`
      this.toEditTime.id = '000001' 
      this.toEditTime.capacity = this.timeCutoff + this.timeFinish + ':00' 
      if(this.switch1 === false){
        this.toEditTime.cartype = 'false'
      }else{
        this.toEditTime.cartype = 'true'
      }
      setTimeout(() => {
          api.put(url,this.toEditTime).then (res =>{
                  console.log(res.data) 
                  if( res.data ) {
                    alert(`Setting Saved!`)
                     this.isSetting = false ;
                    this.$socket.emit('cars_update', this.toEditTime )
                  }
          }).catch(err=>{
             console.log({ message: err.message });
              this.isSetting = false ;
             alert(`Error in Saving Setting`);
          })
       }, 1500);
    },
    setcutOff(){ // tanskie
      
      if(this.timeCutoff.length < 5 || this.timeFinish.length < 5 ){
        swal({title : 'Please Input correct time format '})
       }else{
          let url = `${this.api}updatecarType`
          this.toEditTime.id = '000001' 
          this.toEditTime.capacity = this.timeCutoff + this.timeFinish +':00'   
          console.log(' this.toEditTime.capacity',  this.toEditTime.capacity)   

          if(this.switch1 == false){
            this.toEditTime.cartype = 'false'
          }else{
            this.toEditTime.cartype = 'true'
          }
        api.put(url,this.toEditTime).then (res =>{
                console.log(res.data) 
                // this.loadcutOff()
                let msgTitle = "Save"
                swal( msgTitle, " " , "success" , {
                timer: 1000,
                button:false
            })

        })
      }
    },

    async loadcutOff() {

      const TARGET_ID = '000001';

      try {
        const res = await api.get(`${this.api}cartypelist`);
        
        const record = res.data.find(r => r.id === TARGET_ID);
        if (!record) return console.warn(`Record ${TARGET_ID} not found`);

        const timeCutoff = record.capacity.slice(0, 8);
        const timeFinish = record.capacity.slice(8, 16);
        const isLocked = record.cartype.toLowerCase() === 'true'; // Current DB state

        this.timeCutoff = timeCutoff;
        this.timeFinish = timeFinish;
        this.switch1 = isLocked;

      } catch (err) {
        console.error("Error loading cutoff data:", err.message);
      }
    },

    // async unlockReservation(cutoff, finish) {
    //     console.log('Unlocking reservation...');
        
    //     const payload = {
    //       id: "000001",
    //       capacity: cutoff + finish,
    //       cartype: 'FALSE'
    //     };

    //     try {
    //       await api.put(`${this.api}updatecarType`, payload);
    //       console.log('Reservation successfully unlocked');
    //     } catch (err) {
    //       console.error("Failed to unlock reservation:", err.message);
    //     }
    // },
    
  //  loadcutOff(){     // tanskie
  //       let url =  `${this.api}cartypelist`
  //       api.get(url).then( res => {
  //       this.timeData = res.data.filter(r =>{
  //           return r.id === '000001'
  //         }).map(rec =>{
  //           return {
  //             timeCutoff : rec.capacity.slice(0,8),
  //             timeFinish : rec.capacity.slice(8,16),
  //             switchdata : rec.cartype.toLowerCase() 

  //           }
          
  //         })
    
  //       this.timeCutoff = this.timeData[0].timeCutoff 
  //       this.timeFinish = this.timeData[0].timeFinish
  //       let datavalue = this.timeData[0].switchdata

  //       this.switch1 =  (datavalue === 'true')

  //       // on going 2026-05-13
  //       console.log('Time Now: ', moment().tz("Asia/Manila").format("HH:mm:ss"))
  //       console.log('Time Finish', this.timeData[0].timeFinish )
        
  //       // =================== Unlock Reservation ====================== // 
  //       let timeNow = moment().tz("Asia/Manila").format("HH:mm:ss") 
  //       if( timeNow >= this.timeData[0].timeFinish  ) {
  //          // Unlock Function ( update )
  //           console.log('unlock reservation')
  //           const urlCarType = `${this.api}updatecarType`
  //           let payloadObj =  {
  //              id: "000001",
  //              capacity: this.timeCutoff+ this.timeFinish,
  //              cartype: 'FALSE'
  //           }
  //           console.log('payloadObj', payloadObj )
  //           api.put( urlCarType, payloadObj )

  //       }
  //       else{
  //          console.log('lock reservation');
  //       }

      

  //     }).catch(err=>{
  //        console.log({ message: err.message })
  //     })
  //   },

    addCard(){

      this.counter++;
      this.newCard.push("Card"+this.counter);
      let index = this.counter
      this.modellist[index] = true
      this.allocated[index] = 0
      this.radiosAssign[index] = '0'
  
    },
    countval(items,val){
      
    
    const index = this.newCard.indexOf(items)
  
      this.allocated[index] = val.length
    
      this.listId[index] = _.union(this.listId[index],val.map(rec1 =>{
        return rec1.empId
      }));
    this.selectEmpName = _.union(this.selectEmpName, val.map(rec=>{
        return rec.empId
    }));

  
    for( let i=0; i<val.length; i++ ){
    
      if( typeof(val[i]) == 'string' ){
        this.selectedEmp[index].splice(i, 1)
      }
    }

    },
      cleartext(){
          this.toAddS.Remarks = null
          this.toAddS.EventVenue = null
      },

    openDialog(){
        this.dialog = true
        this.btnName = 'Add'
        // this.radios = 'radio-1'
          this.loadData()
          this.CarswithReserved_Promise()
        this.loadEmpList()
      },
    
    openAddDialog(rec,val){
      this.loadEmpList()
        // console.log(rec,val)

        // this.toAdd = rec[0]
        // if(val == 'regular'){
        this.toAdd.pickupName = null
        this.toAdd.DropPoint = null
        this.toAdd.timeDisplay = rec[0].timeDisplay
        this.toAdd.timeID = rec[0].timeID
        this.toAdd.plateNo = rec[0].plateNo
        this.toAdd.Driver = rec[0].Driver
        this.toAdd.license_no =  rec[0].license_no
        this.toAdd.typeofCar =  rec[0].typeofCar
        this.toAdd.driverContacts =  rec[0].driverContacts
        this.toAdd.Remarks =  rec[0].Remarks
        this.toAdd.capacity = rec[0].capacity
        this.toAdd.designation = rec[0].designation
        this.toAdd.SpecialReq = rec[0].SpecialReq
        this.toAdd.EventVenue = rec[0].EventVenue
        
        if(val == 'special'){
        this.toAdd.R_id = rec[0].R_id
        this.toAdd.R_Name = rec[0].R_Name
        }

        // }
        
          
        this.addDialog = true
        
          // console.log('this.toAdd',this.toAdd)
        //  this.loadData()
        // this.loadEmpList()
      
    },  
    closeAddDialog(){
      this.toAdd = {}
      this.addDialog = false
        this.$refs.formAdd.resetValidation()
            this.$refs.formAdd.reset()
    },

      closeDialog(){
        
        this.toAddS ={}
        this.toAdd = {}
          this.Members = []
          this.MembersList = []
        this.clearAll()
          this.dialog = false
      },
      openDialogAssignReg(val){
        // console.log(val)
        
        this.timeDisplay = val[0].timeDisplay
          this.DialogRegularAssign = true
      
        if (val[0].plateNo !== null){
          
          this.lblAssign = 'Car Reassignment'
          this.plateNo[0] = {plateNo :val[0].plateNo, CarType : val[0].typeofCar, Driver : val[0].Driver}
          this.selectedDriver[0] = {DriverName : val[0].Driver, Contacts : val[0].driverContacts, licenseNo : val[0].license_no }
          this.capacity[0] = val[0].capacity
          this.radiosAssign[0] = val[0].designation.toString()
          this.allocated[0] = val.length
          this.modellist[0] = false
          
              for(let a=0; a < val.length; a++){

                this.ListReserved.push(val[a])
                
                  //   console.log('VALUE')
                  // console.log(val[a])
                
              }
              this.selectedEmp.push(val)
                  this.selectEmpName = val.map(rec1 =>{
                    return rec1.empId
                  })
              
              this.ListofEmpReserved = _.orderBy(val,['DropPoint'],['ASC'])
              this.ListofEmpRes = _.orderBy(val,['DropPoint'],['ASC'])
          }else{
          this.lblAssign = 'Car Assignment'
          this.modellist = [true]
          this.ListReserved = _.orderBy(val,['DropPoint'],['ASC'])
          

          this.ListofEmpReserved = _.orderBy(val,['DropPoint'],['ASC'])

          this.ListofEmpRes = _.orderBy(val,['DropPoint'],['ASC'])
          this.ListofEmpResarvation = _.orderBy(val,['DropPoint'],['ASC'])
          this.CarslistArray[0] = this.CarsList 
          this.allocated[0] = 0
          this.capacity[0] = 0
          this.plateNo[0]= ''
          this.radiosAssign[0] = '0'
            this.selectedEmp[0] = null
        }
        
        this.loadData()
        this.CarswithReserved_Promise()
        this.loadCarsList()
      }, 

    openDialogAssignSpecial(val){
    
        this.timeDisplay = val[0].timeDisplay
          this.DialogSpecialAssign = true
      
        if (val[0].plateNo !== null){
          
          this.lblAssign = 'Car Reassignment'
          this.plateNo[0] = {plateNo :val[0].plateNo, CarType : val[0].typeofCar, Driver : val[0].Driver}
            this.selectedDriver[0] = {DriverName : val[0].Driver, Contacts : val[0].driverContacts, licenseNo : val[0].license_no }
            this.capacity[0] = val[0].capacity
        
          this.allocated[0] = val.length
          this.modellist[0] = false
              for(let a=0; a < val.length; a++){

                this.ListReserved.push(val[a])
                
                  //   console.log('VALUE')
                  // console.log(val[a])
                
              }
              this.selectedEmp.push(val)
                  this.selectEmpName = val.map(rec1 =>{
                    return rec1.empId
                  })
              
              this.ListofEmpReserved = _.orderBy(val,['DropPoint'],['ASC'])
          
          }else{
              this.lblAssign = 'Car Assignment'
          this.modellist = [false]
            for(let a=0; a < val.length; a++){

                this.ListReserved.push(val[a])
                
                  //   console.log('VALUE')
                  // console.log(val[a])
                
              }
              this.selectedEmp.push(val)
                  this.selectEmpName = val.map(rec1 =>{
                    return rec1.empId
                  })
          this.ListofEmpReserved = _.orderBy(val,['DropPoint'],['ASC'])
          this.ListofEmpRes = _.orderBy(val,['DropPoint'],['ASC'])
          this.ListofEmpResarvation = _.orderBy(val,['DropPoint'],['ASC'])
          this.CarslistArray[0] = this.CarsList 
          this.allocated[0] = val.length
          this.capacity[0] = 0
          this.plateNo[0]= ''
        }
          this.loadData()
          this.CarswithReserved_Promise()
        this.loadCarsList()
      }, 
      

      closeDialogAssignReg(){
        this.DialogRegularAssign = false
        this.DialogSpecialAssign = false
        this.ListofEmpReserved = []
        
        this.details = []
        this.selectedDriver = []
        this.listId = []
        this.plateNo = []
        this.ListReserved = []
        this.selectEmpName = [] 
        this.capacity = []
        this.selectedEmp = []
        this.counter = 0
        this.newCard = ['Card0']
      //  this.isLoading = false  
      }, 

      transferReserved(val){
            this.employeeListperTime = val

            this.toAdd = val[0]
            this.timeDisplay =  val[0].timeDisplay
        //   console.log('VALUE')
        // console.log(val)
          this.loadSchedule()
            this.transferDialog = true         
      },
      closeDialogTrans(){
        this.transferDialog = false
        this.toAdd ={}
        this.toLabel ={}
    
      },
      
    clearAll(){
          this.toAdd = {}
            this.toLabel={}
            this.toAddS ={}   
            
            this.$refs.form1.reset()
              this.$refs.form2.reset()
              this.$refs.form1.resetValidation() 
            this.$refs.form2.resetValidation()

          
    },
      remove (item) {
        var index = this.Members.map( (e) => {
          return e.empId 
        }).indexOf(item)

      
      if (index >= 0) this.Members.splice(index, 1)

    },
    removeSpcialReserved(item){
        const index = this.Members.indexOf(item)
      if (index >= 0) this.Members.splice(index, 1)
    },

    removeAssgnEmp(val,items){

      var i = this.newCard.indexOf(items)
      var index = this.selectedEmp[i].indexOf(val)

        this.selectEmpName = _.pull(this.selectEmpName, val.empId);
        this.listId[i] =_.pull(this.listId[index],val.empId) 
  

      if (index >= 0) this.selectedEmp[i].splice(index,1)
      if(this.selectedEmp[i].length ===0) this.selectedEmp[i] = null
      this.allocated[i] = this.allocated[i] - 1

        this.ListofEmpReserved = this.ListofEmpRes.filter(r =>{
        return !this.selectEmpName.includes(r.empId)
        })
    
        
    },
    

    test() {
        if ( this.radios == 'radio-2') {
          this.clearAll()
            this.isRegular = false
            this.isSpecial = true
            this.$refs.form1.reset()
            this.$refs.form1.resetValidation()
            this.$refs.form2.resetValidation()
        
        } else if (this.radios == 'radio-1'){
          this.clearAll()
            this.isRegular = true
            this.isSpecial = false
            this.$refs.form2.reset()
            this.$refs.form2.resetValidation()
            this.$refs.form1.resetValidation()
          
        }
          
    },

    getReservationwithPlateNo_Promise(){
      return new Promise((resolve) =>{
        let url = `${this.api}reservation/${this.dateToday}`
          api.get(url).then(res => {
            
        this.groupByPlateNo = _.chain(res.data.filter(r=>{
          return r.plateNo !== null
        }))
        .groupBy('plateNo').map(v=>({
          plateNo : v[0].plateNo,
          capacity : v[0].capacity,
          recs : v
        })).value()
        resolve(this.groupByPlateNo)
        })
        
      })
      
    },  

    async CarswithReserved_Promise(){
      try{
        const CarsWith = await this.getReservationwithPlateNo_Promise();
        // console.log('1212',CarsWith)
          this.CarswithReserved = CarsWith.filter(rec2 =>{
              return rec2.capacity - 1 === rec2.recs.length 
            }).map(r2 =>{
              return r2.plateNo
            })
          // console.log(this.CarswithReserved)  
      }catch(err){
        console.log(err)
      }
    } ,

    loadData(){
          let url = `${this.api}reservation/${this.dateToday}`  

          api.get(url).then(res =>{   
            
          this.listofIDreserved = res.data.map(rec1 =>{
            return rec1.empId
          })

            // Getting No Plate No Yet ( Regular )
          this.RegularwithoutPlateNo = res.data.filter(rec =>{
            return rec.plateNo == null && rec.SpecialReq == false
          }).length

        })
      },
    
    loadCarsList(){

      this.selectedPlateNumber = this.plateNo.map(r =>{
        return r.plateNo
      })

      let url =`${this.api}carlist`
      api.get(url).then(res =>{
        this.CarsList = res.data.filter(rec =>{
                return rec.Status !== 'Unused' && !this.CarswithReserved.includes(rec.PlateNo) && !this.selectedPlateNumber.includes(rec.PlateNo) 
        }).map(r =>{
          return {plateNo : r.PlateNo,
                  CarType : r.CarType,
                  Driver : r.Driver,
                  codeDay : r.Day_Code}
        })
      })

    },
  
    
    loadDriverList(){
        let url = `${this.api}driversList`
        api.get(url).then(res =>{
          this.DriverList = res.data.filter(rec =>{
            return rec.available !== 'No'
          }).map(r =>{
            return {DriverName : r.name,
                    Contacts : r.Contacts,
                    licenseNo : r.license_id}
          })
          
        })
    },  
  

    // loaduserslist(){
    //    let url =  `${this.api}getUsers`
    //    api.get(url).then( res => {
    //       this.userList = res.data

    //       this.userListID = res.data.map(rec => {
    //         return rec.id
    //        })
          

    //   }) 

    //  },
      loadEmpList(){   // 2022-01-31
        let Guest_users = []
        let employeeListRegular = []
        let employeeListSpecial = []
        let url =  `${this.api}getUserswithCars`
        api.get(url).then(res =>{
            if(res.data) {             
                // Regular
                let url2 = `${this.api}guest_users`
                api.get(url2).then(res2=>{
                  
                  if(res2.data) {

                      Guest_users =  _.orderBy(res2.data, ['LastNameEng'], ['ASC']).filter( rec1 => {
                       return !this.listofIDreserved.includes(rec1.id) && rec1.id !== this.userData.id
                      }).map(rec2 => {
                          return {EmpName: rec2.LastNameEng + ', ' + rec2.FirstNameEng,
                                  empId : rec2.id, localNumber : rec2.localNumber,
                                  DropPoint: rec2.DropPoint, pickupName: rec2.PickUpPoint,
                                    }
                      })

                     // Regular
                     employeeListRegular = _.orderBy(res.data, ['LastNameEng'], ['ASC']).filter( rec1 => {
                        return !this.listofIDreserved.includes(rec1.id) && rec1.id !== this.userData.id
                      }).map(rec2 => {
                          return {EmpName: rec2.LastNameEng + ', ' + rec2.FirstNameEng,
                                  empId : rec2.id, localNumber : rec2.localNumber,
                                  DropPoint: rec2.DropPoint, pickupName: rec2.PickUpPoint,
                                    }
                      })

                      this.employeelistR = [...employeeListRegular, ...Guest_users]

                      // Special
                      employeeListSpecial =  _.orderBy(res.data, ['LastNameEng'], ['ASC']).filter( r =>{
                              return r.id !== this.toAddS.empId && !this.listofIDreserved.includes(r.id) && r.id !== this.userData.id
                          }).map(rec =>{
                            return {EmpName: rec.LastNameEng + ', ' + rec.FirstNameEng,
                                  empId : rec.id, localNumber : rec.localNumber,
                                  PickUpPoint: rec.PickUpPoint,
                                    }
                      })


                      this.employeeList = [...employeeListSpecial, ...Guest_users ]
                  }

              
                })


              
            }
            
            
        })
      },
    
      selectLicense(val){
        let index = this.selectedDriver.indexOf(val)
        // console.log(val)
        if (val === undefined){
          this.selectedDriver[index] = {}
          
        }else{
          this.selectedDriver[index] = val
          
        }
      
      },

      selectPlateNo(val){
        console.log('pl',val)
        let index = this.plateNo.indexOf(val)
        this.$refs.form.resetValidation()
        if(val === undefined){   

          this.capacity[index] = '0'
          this.model = []
          this.details = []
          this.selectedDriver[index] = {}
          this.selectedDriver[index] = ''
          this.modellist[index] = true
          this.plateNo[index] = ''
          this.selectedPlateNumber[index] = null
          // this.selectedPlateNumber.splice(index,1)
            this.loadData()
            this.CarswithReserved_Promise()
            this.loadCarsList()
        }else{
          // this.selectedPlateNumber.push(this.plateNo[0])
          

          this.modellist[index] = false
          this.cartypeof = val.CarType 
        //  this.selectedDriver = val.Driver
          this.details = this.DriverList.filter(rec =>{
              return rec.DriverName === val.Driver
              }) 
              
          if(this.details.length !== 0){

              this.selectedDriver[index] = {DriverName : this.details[0].DriverName,
                    Contacts : this.details[0].Contacts,
                    licenseNo : this.details[0].licenseNo}  
                  
          }else{
            
            this.selectedDriver[index] ={}
          }
          this.loadData()
          this.CarswithReserved_Promise()
          this.loadCarsList()

          // let url =  `${this.api}cartypelist`
          // api.get(url).then( res => {
          // this.capacity[index] = res.data.filter(rec =>{
          //   return rec.cartype == val.CarType && rec.id !== '000001'
          // }).map(r =>{
          //   return r.capacity
          // })

          this.capacity[index] = this.CarsTypeList.filter(rec =>{
              return rec.cartype == val.CarType
          }).map(r =>{
            return r.capacity
          })

        // this.capacity[index] = b


          if(this.details.length === 0){
          // this.selectedDriver[index] = '' 
          this.selectedDriver[index] = {}
        } 

        // })
        }
        
        
      },
      selectedAdd(val){
        if(val === undefined){
          this.toAdd = {}
        }else{
          if(this.toAdd.SpecialReq == true){
            this.toAdd.DropPoint = val.DropPoint
        this.toAdd.empId  = val.empId
        this.toAdd.DateScheduled = this.dateToday
        this.toAdd.EmpName = val.EmpName
        this.toAdd.pickupName = val.pickupName
        this.toAdd.localNumber = val.localNumber
          }else{
            this.toAdd.DropPoint = val.DropPoint
        this.toAdd.empId  = val.empId
        this.toAdd.DateScheduled = this.dateToday
        this.toAdd.EmpName = val.EmpName
        this.toAdd.pickupName = val.pickupName
        this.toAdd.R_id = val.empId
        this.toAdd.R_Name = val.EmpName
        this.toAdd.localNumber = val.localNumber
          }
            
          
        }

      },


      selectEmpDataR(val){   
        // console.log(val)
            if(val === undefined){
              this.toAdd = {}
              this.toLabel.ScheduleTime = ''
            }else{
                this.toAdd.DropPoint = val.DropPoint
                this.toAdd.empId  = val.empId
                this.toAdd.DateScheduled = this.dateToday
                this.toAdd.SpecialReq = false 
                this.toAdd.EmpName = val.EmpName
                this.toAdd.pickupName = val.pickupName
                this.toAdd.R_id = val.empId
                this.toAdd.R_Name = val.EmpName
                this.toAdd.localNumber = val.localNumber    
                this.toAdd.plateNo = null  
                this.toAdd.Driver = null
                this.toAdd.license_no = null
                this.toAdd.typeofCar = null
                this.toAdd.driverContacts = null
                this.toAdd.Remarks = null
                this.toAdd.designation = 0  
            }
      },
      selectEmpDataS(val){   
            if(val === undefined){
              this.toAddS = {}
            }else{  
              this.toAddS.R_id = val.empId
                this.toAddS.R_Name = val.EmpName  
                this.toAddS.empId  = val.empId                             
                this.toAddS.EmpName = val.EmpName
                this.toAddS.pickupName = val.pickupName
                this.toAddS.localNumber = val.localNumber  
                this.toAddS.DropPoint = val.DropPoint
                this. loadEmpList()
            }
            //  this. loaduserslist()
            
      },

      selectTime(val){    
        if(val === undefined){
          this.toAdd.timeDisplay = ''
          this.toAdd.timeID = ''
        }else{
          this.toAdd.timeDisplay = val.timeDisplay    
        this.toAdd.timeID = val.timeID 
        }    
      },
      selectTimeS(val){    
        if(val === undefined){
          this.toAddS.timeDisplay = ''
          this.toAddS.timeID = ''
        }else{
          this.toAddS.timeDisplay = val.timeDisplay    
        this.toAddS.timeID = val.timeID 
        }    
      },

      selectDropName(val){
          if(this.radios === 'radio-1'){
             this.toAdd.DropName = val
          }else{
              this.toAddS.DropName = val
          }
      },
      
      selectPickUpName(val){
        if(this.radios === 'radio-1'){
          this.toAdd.pickupName = val
        }else{
          this.toAddS.pickupName = val
          
        }
        
      },

    loadSchedule(){
      let url = `${this.api}getTimesched`
      api.get(url).then ( res => {
        // this.timeIDlist = res.data

      // for regular time sched
          this.ScheduleTime = res.data.filter(rec =>{
                return rec.useSpecial == false           
              }).map( rec1 => {
                return {timeDisplay: rec1.timeDisplay,
                        timeID : rec1.timeID }
              }).sort((a,b) => (a.timeDisplay > b.timeDisplay) ? 1 : ((b.timeDisplay > a.timeDisplay) ? -1 : 0))


        //  if(this.dayToday !== 'Friday'){
            
        //   }else{
        //     this.ScheduleTime = res.data.filter(rec =>{
        //     return rec.useSpecial == false && (rec.timeSched === '16:45' || rec.timeSched ==='17:45' || rec.timeSched ==='18:00')           
        //      }).map( rec1 => {
        //     return {timeDisplay: rec1.timeDisplay,
        //            timeID : rec1.timeID }
        //     }).sort((a,b) => (a.timeDisplay > b.timeDisplay) ? 1 : ((b.timeDisplay > a.timeDisplay) ? -1 : 0))

        //   }  
          

///// for special time sched
        this.ScheduleTimeS = res.data.filter(rec =>{
          return rec.useSpecial === true           
        }).map( rec1 => {
            return {timeDisplay: rec1.timeDisplay,
                    timeID : rec1.timeID }
        }).sort((a,b) => (a.timeDisplay > b.timeDisplay) ? 1 : ((b.timeDisplay > a.timeDisplay) ? -1 : 0))

    
    //  if(this.dayToday !== 'Friday'){
    //           }else{
    //       this.ScheduleTimeS = res.data.filter(rec =>{
    //       return rec.useSpecial === true  && (rec.timeSched < '18:00' || rec.timeSched > '19:30')          
    //     }).map( rec1 => {
    //        return {timeDisplay: rec1.timeDisplay,
    //                timeID : rec1.timeID }
    //     }).sort((a,b) => (a.timeDisplay > b.timeDisplay) ? 1 : ((b.timeDisplay > a.timeDisplay) ? -1 : 0))

    //  }      

//// for transfer time
          this.transTime = res.data.filter(rec =>{
          return rec.useSpecial === false && rec.timeDisplay !== this.timeDisplay       
        }).map( rec1 => {
            return {timeDisplay: rec1.timeDisplay,
                    timeID : rec1.timeID }
        }).sort((a,b) => (a.timeDisplay > b.timeDisplay) ? 1 : ((b.timeDisplay > a.timeDisplay) ? -1 : 0))

      //  if(this.dayToday !== 'Friday'){
      //                // console.log(this.timeIDlist)
      //  }else{
      //     this.transTime = res.data.filter(rec =>{
      //     return rec.useSpecial === false && rec.timeDisplay !== this.timeDisplay  && (rec.timeSched === '16:45' || rec.timeSched ==='17:45' || rec.timeSched ==='18:00')             
      //   }).map( rec1 => {
      //      return {timeDisplay: rec1.timeDisplay,
      //              timeID : rec1.timeID }
      //   }).sort((a,b) => (a.timeDisplay > b.timeDisplay) ? 1 : ((b.timeDisplay > a.timeDisplay) ? -1 : 0))

      //  }
      })
    },

    loadDropPoint(){
      let url = `${this.api}getDropPoint`
      api.get(url).then (res => {
        this.DropPointList = res.data.filter( rec =>{
          return rec.SelectUse == 'Yes'
        }).map( rec1 => {
          return rec1.PointName
        })
      })
    },
    

    loadPickUpPoint(){
      let url = `${this.api}getPickPoint`
      api.get(url).then (res => {
        this.PickupList = res.data.filter( rec =>{
          return rec.SelectUse == 'Yes'
        }).map( rec1 => {
          return rec1.PointName
        })
      })
    },
    loadAllReservation(){
        let url = `${this.api}AllReservation/${this.dateToday}`
        api.get(url).then(res =>{
        //  this.allCarsReservation = res.data.filter(rec =>{
        //    return rec.SpecialReq == false
        //  })
        //   this.SpecialcarsReservationData = res.data.filter(rec1 =>{
        //     return rec1.SpecialReq == true
        //   })
        

          this.RegularcarsReservationData = res.data[0]
          this.SpecialcarsReservationData = res.data[1]

          // Getting No Plate No Yet ( Special )
          this.SpecialwithoutPlateNo = res.data[1].filter(rec=>{
              return rec.PlateNo == null
          }).length

          // 
          // console.log('Reg_NoPlateNo.',this.RegularwithoutPlateNo);
          // console.log('Special_NoPlateNo', this.SpecialwithoutPlateNo);

          this.isLoading = false
      
        })
        .catch(err => {
          console.log('errorrrrr')
          console.log(err)
        })
        
    },

    SaveAssign(){
      this.loading = true

        if(this.lblAssign === 'Car Reassignment'){

          let url1 = `${this.api}AddSched`
            for(let b = 0; b < this.remaining_list.length; b++){

              this.toAdd= this.remaining_list[b]
              this.toAdd.plateNo = null    
              this.toAdd.Driver = null
              this.toAdd.license_no = null
              this.toAdd.typeofCar = null
              this.toAdd.capacity = null 
              this.toAdd.driverContacts = null
              this.toAdd.designation = 0
              this.toAdd.Day_Code = null

              api.post(url1, this.toAdd).then (res => {
              console.log (res.data)
              this.$socket.emit('cars_update', this.toAdd )
                    
               })
            }
        }  
        
            let url = `${this.api}AddSched`
            for(let i = 0; i < this.selectedEmp.length; i++){
              for(let a = 0; a < this.selectedEmp[i].length; a++  ){
                // setTimeout(()=>{
              
              this.toAdd= this.selectedEmp[i][a]

                this.toAdd.plateNo = this.plateNo[i].plateNo  
                this.toAdd.Day_Code = this.plateNo[i].codeDay
                
                this.toAdd.Driver = this.selectedDriver[i].DriverName
                this.toAdd.license_no = this.selectedDriver[i].licenseNo
                this.toAdd.typeofCar = this.plateNo[i].CarType
                this.toAdd.capacity = parseInt( this.capacity) 
                this.toAdd.driverContacts = this.selectedDriver[i].Contacts
                this.toAdd.designation = parseInt(this.radiosAssign[i])

              api.post(url, this.toAdd).then (res => {
              console.log (res.data)
              this.$socket.emit('cars_update', this.toAdd )
              let msgTitle = "Successfully Assign"
              swal( msgTitle, " " , "success" , {
                timer: 1000,
                button:false
                })
              // this.autoUnlock()
              this.closeDialogAssignReg() 
              this.loading = false
                
              this.loadCarsList()
              
                })
                    console.log(this.toAdd)
              // },3000)
              
            } 
        }
    },
    autoUnlock(){
        this.loading = true
        let url = `${this.api}reservation/${this.dateToday}`
        api.get(url).then(res =>{
          this.ListofNull = res.data.filter(rec =>{
            return rec.plateNo == null
          }).map(r =>{
            return r.plateNo
          })
          if (this.ListofNull.length === 0){
            if(this.switch1 === true){
              this.switch1 = false
              this.ReservedLock()
            }
            
          }
    
          this.loading = false
        })
        
    },

    AdditionalReservation(){
      let url = `${this.api}AddSched`
      api.post(url,this.toAdd).then(res =>{
        console.log(res.data)
          let msgTitle = "Successfully Added Reservation"
                swal( msgTitle, " " , "success" , {
                timer: 1000,
                button:false
            })
            this.$socket.emit('cars_update', this.toAdd )
            // this.loadAllReservation()
        this.closeAddDialog()
      })
    },
  
    
    AddReserved(){
    
    
      let url = `${this.api}AddSched`
        if(this.radios === 'radio-1'){
          
              api.post(url, this.toAdd).then (res => {
            console.log (res.data)
                
                let msgTitle = "Successfully Reserved"
                swal( msgTitle, " " , "success" , {
                timer: 1000,
                button:false
            })
            this.$socket.emit('cars_update', this.toAdd )
            // this.loadAllReservation()
            this.closeDialog()
            
            })

          // setTimeout(() => {
          // this.loadReservation()
          // }, 500);
          
        }else if(this.radios === 'radio-2'){

          this.transferMem.EmpName = this.toAddS.EmpName
          this.transferMem.empId = this.toAddS.R_id
            this.transferMem.PickUpPoint = this.toAddS.pickupName
          this.transferMem.localNumber = this.toAddS.localNumber
          this.MembersList.push(this.transferMem)

          for(let a = 0; a< this.Members.length; a++){
            this.MembersList.push(this.Members[a])
          }
            console.log(this.MembersList)
              for (let i = 0; i < this.MembersList.length; i++){
              setTimeout(() =>{
              this.toAddS.EmpName = this.MembersList[i].EmpName
            this.toAddS.empId = this.MembersList[i].empId 
            this.toAddS.pickupName = this.MembersList[i].PickUpPoint 
            this.toAddS.localNumber = this.MembersList[i].localNumber
            this.toAddS.DateScheduled = this.dateToday
            this.toAddS.SpecialReq = true
            this.toAddS.plateNo = null
            this.toAddS.typeofCar = null
            this.toAddS.driverContacts = null
            this.toAddS.Driver = null
            this.toAddS.license_no = null
            this.toAddS.designation = 0
            

            let url = `${this.api}AddSched`
                api.post(url, this.toAddS).then (res => {
              console.log (res.data)
              this.$socket.emit('cars_update', this.toAddS )
              let msgTitle = "Successfully Reserved"
              swal( msgTitle, " " , "success" , {
              timer: 1000,
              button:false
          })
          
                //  this.loadAllReservation()
                this.closeDialog()
                
                })
              
            }, 500)  
                    
        }
          this.$socket.emit('cars_update', this.toAddS )    

      //      if(this.dayToday !== 'Friday'){
      //         //  alert(this.dayToday)
          
      //  }else{
      //    if(this.MembersList.length < 4){
      //       alert('Need 4 person and above for Special Reservation')
      //     this.MembersList = []
      //    }else{
      //      for (let i = 0; i < this.MembersList.length; i++){
      //        setTimeout(() =>{
      //        this.toAddS.EmpName = this.MembersList[i].EmpName
      //       this.toAddS.empId = this.MembersList[i].empId 
      //       this.toAddS.pickupName = this.MembersList[i].PickUpPoint 
      //       this.toAddS.localNumber = this.MembersList[i].localNumber
      //       this.toAddS.DateScheduled = this.dateToday
      //       this.toAddS.SpecialReq = true
      //       this.toAddS.plateNo = null
      //       this.toAddS.typeofCar = null
      //       this.toAddS.driverContacts = null
      //       this.toAddS.Driver = null
      //       this.toAddS.license_no = null
      //       this.toAddS.designation = 0
            

      //      let url = `${this.api}AddSched`
      //          api.post(url, this.toAddS).then (res => {
      //         console.log (res.data)
      //          this.closeDialog()
                
      //           })
              
      //      }, 500)  

      //    }
      //    }
          
      //  }

          this.isLoading =false  
          }
    },
    transferRes(){
      
          let msgTitle = "Successfully Transfer"
              swal( msgTitle, " " , "success" , {
              timer: 1000,
              button:false
          })
        let url = `${this.api}AddSched`
        api.post(url, this.toAdd).then (res => {
        console.log (res.data)
        this.$socket.emit('cars_update', this.toAdd )
      })
        
        this.closeDialogTrans()
        // this.loadAllReservation()
    },

    cancelReservation(empId,empName) {

        let msgDelete = ""
        let msgYes = ""
        let msgNo = ""
        if (this.$i18n.locale === 'en') {
          msgDelete = 'Do you want to cancel ' + empName +' reservation?'
          msgYes = "YES"
          msgNo = "NO"
          } else {
          msgDelete = '予約をキャンセルしますか？'
          msgYes = "はい "
          msgNo = "いいえ"
          }
        swal({
        title: msgDelete,
        icon : 'warning',
        closeOnEsc: false,
        closeOnClickOutside: false,
        buttons : [ msgYes,  msgNo]
          
        }).then( (willApprove)=>{
            if (!willApprove) {
              let url = `${this.api}deleteReservation/${empId}`
            api.delete(url).then( res => {
              this.$socket.emit('cars_update', empId )
            //  console.log('line1926')
              console.log(res.data)
                  this.snackbar= true
              
                  // this.loadAllReservation()
                  // this.loadData()  
                  this.CarswithReserved_Promise()               
              })                             
            }
        })

      
    },

    SaveRemarks(){
      if(this.btnRemarks == 'Add'){
        let url = `${this.api}addRemarks`
        this.vRemarks.switch = this.vRemarksSwitch
      
      api.post(url, this.vRemarks).then(res =>{
        // this.employeedata = res.data
        if(res.data) {
            console.log(res.data)
            alert('Remarks Successfully Added')
            this.$socket.emit('cars_update', this.vRemarks )
            location.reload()
            
        }        
      } ) 
      }else{
        let url = `${this.api}updateRemarks`
        this.vRemarks.switch = this.vRemarksSwitch
        api.put(url, this.vRemarks).then(res =>{
          if(res.data){
            alert('Remarks Successfully Updated')
            this.$socket.emit('cars_update', this.vRemarks )
            location.reload()
          }
        })
      }
      this.remarksDialog = false;
    },

    loadCarTypeList(){
      let url =  `${this.api}cartypelist`
          api.get(url).then( res => {
          this.CarsTypeList = res.data.filter(rec =>{
            return  rec.id !== '000001'
          })
          }) 
    }


},
  mounted: function(){
    
      // setInterval( () => {
      //     this.timeToday = moment().tz("Asia/Manila").format("HH:mm:ss")

      //     if(this.autoSwitch == true){
          
      //       if(this.timeCutoff+':00' <= this.timeToday){  // 08:00:00 
      //         if(this.timeFinish+':00' >= this.timeToday){
      //           if(this.AllCount > 0){
      //             if(this.FinishData.SelectUse == 'True'){
      //               if(this.switch1 == true){
      //                 this.switch1 = false;
      //                 this.ReservedLock();
      //               }
      //             }else{
      //               if(this.FinishData.SelectUse == 'False'){
      //                 if(this.switch1 == false){
      //                   this.switch1 = true;
      //                   this.ReservedLock();
      //                 }
      //               }
      //             }
      //           }else{
      //               if(this.FinishData.SelectUse == 'False'){
      //                 if(this.switch1 == false){
      //                   this.switch1 = true;
      //                   this.ReservedLock();
      //                 }
      //               }else{
      //                 if(this.switch1 == true){
      //                   this.switch1 = false
      //                   this.ReservedLock()
      //                 }
      //               }
      //           }
      //         }else{
      //           if(this.switch1 == true){
      //             this.switch1 = false;
      //             this.ReservedLock()
      //           }
      //         }
      //       }else{
      //         if(this.switch1 == true){
      //           this.switch1 = false;
      //           this.ReservedLock();
      //         }
      //       }
      //     }
      // }, 2000)
  },

  

}

</script>

<style scoped>
table,th,td {
border: 1px solid grey !important;
}
td{
padding: 3px !important;
}

th{  
  background-color: #213c57 !important;
  color:white !important;
  font-family: Arial !important;
  padding:15px !important;
  font-size:13px;
}
tr:hover {
background-color: #cdcdd1 !important;
} 
.swal-button--cancel {
  background: #57c0f7 !important;
  color: white !important;
}
.swal-button--confirm {
  background: #dedad9 !important;
  color : #4d4e4f !important;
}


.centered-input input {
text-align: center !important;
font-size: 20px !important;
font-family:Verdana !important;
}
.roundCard {
  border-radius:25px !important;
}
.active {
border: 2px solid gray;
border-bottom: 0;
border-radius: 5px 5px 0 0;
background-color: white;

color: #247ef2;
}

.bb {
border-bottom: 2px solid gray;

}

.tabs {
position: relative;
top: 2px;
}


@media screen and (min-width: 601px) {
.s {
  font-size: 14px !important;
}
}


@media screen and (max-width: 600px) {
.s {
  font-size: 8px !important;
}
}
</style>

